import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThespritersresourceComponent } from './simple-icons-thespritersresource.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThespritersresourceComponent ],
    exports:      [ SimpleIconsThespritersresourceComponent ],
    bootstrap:    []
})
export class SimpleIconsThespritersresourceModule {}
